import { ContentBlock } from "../../types/contentBlock";
import { LandscapeAsset } from "../../types/landscapeAsset";
import { AssetQuery } from "./asset";

export const assetLandscapeQuery = `
    _type == 'assetLandscape' => 
        _type,
        asset ${AssetQuery},
        mobileAsset ${AssetQuery},
        aspectRatio
`

export const isLandscapeAsset = (block: ContentBlock): block is LandscapeAsset => {
    return block._type === 'assetLandscape';
}

